/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import { useAmp } from 'next/amp';
import Style from './Footer24.css';
import ContainerHome24 from '../../atoms/ContainerHome24';

function Footer24({ importPrefix }) {
  const isAmp = useAmp();
  const [accordion, setAccordion] = useState(null);

  const updateAccordion = (index) => {
    if (index === accordion) setAccordion(null);
    else setAccordion(index);
  };

  const getAccordionClass = (index) => {
    if (isAmp) return '';
    return accordion === index ? 'content-expanded' : 'content-hidden';
  };

  const MobileContent = (
    <>
      <section className="column" on="expand:AMP.setState({footerActive: 0})">
        <header
          className="acc-block"
          onClick={(ev) => {
            ev.preventDefault();
            updateAccordion(0);
          }}
        >
          <div className="acc-head">
            <span className="footer-topics">Meu financiamento</span>
            <span
              data-amp-bind-class="footerActive == 0 ? 'rotate': ''"
              className={!isAmp && accordion === 0 ? 'rotate' : ''}
            >
              {isAmp && (
                <amp-img
                  layout="fill"
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}
              {!isAmp && (
                <img
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}
            </span>
          </div>
        </header>
        <div className={getAccordionClass(0)}>
          <div>
            <a
              href={`${importPrefix}boleto.html`}
              id="segunda-via-de-boletos-footer-mobile"
              className="footer-itens"
            >
              <span>Meus boletos</span>
            </a>
            <a
              href={`${importPrefix}consultar-financiamento.html`}
              id="consultar-financiamento-footer-mobile"
              className="footer-itens"
            >
              <span>Consultar Financiamento</span>
            </a>
            <a
              href={`${importPrefix}renegociacao-santander-financiamentos.html`}
              id="renegociacao-footer-mobile"
              className="footer-itens"
            >
              <span>Renegociação</span>
            </a>
            <a
              href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:footer&int_campaign=resumo-copia-de-contrato"
              target="_blank"
              rel="noopener"
              id="resumo-copia-contrato-footer-mobile"
              className="footer-itens"
            >
              <span>Resumo e/ou cópia do contrato</span>
            </a>
            <a
              href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:footer&int_campaign=transferencia-de-financiamento"
              target="_blank"
              rel="noopener"
              id="transferencia-do-financiamento-footer-mobile"
              className="footer-itens"
            >
              <span>Transferência do Financiamento</span>
            </a>
          </div>
        </div>
      </section>
      <section className="column" on="expand:AMP.setState({footerActive: 1})">
        <header
          className="acc-block"
          onClick={(ev) => {
            ev.preventDefault();
            updateAccordion(1);
          }}
        >
          <div className="acc-head">
            <span className="footer-topics">Produto</span>
            <span
              data-amp-bind-class="footerActive == 1 ? 'rotate': ''"
              className={!isAmp && accordion === 1 ? 'rotate' : ''}
            >
              {isAmp && (
                <amp-img
                  layout="fill"
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}

              {!isAmp && (
                <img
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}
            </span>
          </div>
        </header>
        <div className={getAccordionClass(1)}>
          <div>
            <a
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=footer&int_campaign=simular#/dados-pessoais"
              target="_blank"
              rel="noopener"
              id="simular-agora-footer-mobile"
              className="footer-itens"
            >
              <span>Simular agora</span>
            </a>
            <a
              href={`${importPrefix}banco-do-auto.html`}
              id="financiar-veiculos-footer-mobile"
              className="footer-itens"
            >
              <span>Financiar veículos</span>
            </a>
            <a
              href={`${importPrefix}financiamento-entre-particulares.html`}
              id="financiamento-entre-particulares-footer-mobile"
              className="footer-itens"
            >
              <span>Financiar veículo particular</span>
            </a>
            <a
              href={`${importPrefix}financiar-veiculos-eletricos.html`}
              id="financiar-veiculos-eletricos-footer-mobile"
              className="footer-itens"
            >
              <span>Veículos elétricos</span>
            </a>
            <a
              href={`${importPrefix}seguro-santander-auto.html`}
              id="seguro-santander-auto-footer-mobile"
              className="footer-itens"
            >
              <span>Seguro Auto</span>
            </a>
            <a
              href={`${importPrefix}leilao-de-veiculos.html`}
              id="leilao-de-veiculos-footer-mobile"
              className="footer-itens"
            >
              <span>Leilão de veículos</span>
            </a>
            <a
              href={`${importPrefix}open-finance.html`}
              id="open-finance-footer-mobile"
              className="footer-itens"
            >
              <span>Open Finance</span>
            </a>
            <a
              href={`${importPrefix}emprestimo-garantia-carro.html`}
              id="emprestimo-garantia-carro-footer-mobile"
              className="footer-itens"
            >
              <span>Empréstimo com Garantia de Veículo</span>
            </a>
          </div>
        </div>
      </section>
      <section className="column" on="expand:AMP.setState({footerActive: 2})">
        <header
          className="acc-block"
          onClick={(ev) => {
            ev.preventDefault();
            updateAccordion(2);
          }}
        >
          <div className="acc-head">
            <span className="footer-topics">Ajuda</span>
            <span
              data-amp-bind-class="footerActive == 2 ? 'rotate': ''"
              className={!isAmp && accordion === 2 ? 'rotate' : ''}
            >
              {isAmp && (
                <amp-img
                  layout="fill"
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}

              {!isAmp && (
                <img
                  layout="fill"
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}
            </span>
          </div>
        </header>
        <div className={getAccordionClass(2)}>
          <div>
            <a
              href={`${importPrefix}canais-de-atendimento.html`}
              id="canais-de-atendimento-footer-mobile"
              className="footer-itens"
            >
              <span>Canais de atendimento</span>
            </a>
            <a
              href={`${importPrefix}duvidas-frequentes.html`}
              id="duvidas-frequentes-footer-mobile"
              className="footer-itens"
            >
              <span>Dúvidas frequentes</span>
            </a>
            <a
              href={`${importPrefix}denuncias-e-fraudes.html`}
              id="denuncias-e-fraudes-footer-mobile"
              className="footer-itens"
            >
              <span>Fraudes e segurança</span>
            </a>
          </div>
        </div>
      </section>
      <section className="column" on="expand:AMP.setState({footerActive: 3});">
        <header
          className="acc-block"
          onClick={(ev) => {
            ev.preventDefault();
            updateAccordion(3);
          }}
        >
          <div className="acc-head">
            <span className="footer-topics">Termos e condições</span>
            <span
              data-amp-bind-class="footerActive == 3 ? 'rotate': ''"
              className={!isAmp && accordion === 3 ? 'rotate' : ''}
            >
              {isAmp && (
                <amp-img
                  layout="fill"
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}

              {!isAmp && (
                <img
                  layout="fill"
                  alt="Ícone de seta para baixo"
                  src={`${importPrefix}static/amp/shared/assets/ic_arrow_down.svg`}
                />
              )}
            </span>
          </div>
        </header>
        <div className={getAccordionClass(3)}>
          <div>
            <a
              href={`${importPrefix}assets/seguro/pdf/14-11-25-em-diante.pdf`}
              target="_blank"
              id="condicoes-gerais-de-CDC-Auto-footer-mobile"
              className="footer-itens"
            >
              <span>Condições gerais de CDC Auto</span>
            </a>
            <a
              href={`${importPrefix}pdf/emprestimo-garantia-carro/condicoes-gerais-SIM-santander.pdf`}
              target="_blank"
              id="condicoes-gerais-de-emprestimo-com-garantia-de-veiculo-footer-mobile"
              className="footer-itens"
            >
              <span>Condições gerais de Empréstimo com garantia de veículo</span>
            </a>
            <a
              href={`${importPrefix}pdf/Tabela-de-Tarifas.pdf`}
              target="_blank"
              id="tabela-de-tarifas-footer-mobile"
              className="footer-itens"
            >
              <span>Tabela de tarifas</span>
            </a>
            <a
              href={`${importPrefix}politica-de-privacidade.html`}
              id="politica-de-privacidade-footer-mobile"
              className="footer-itens"
            >
              <span>Política de privacidade</span>
            </a>
            <a
              href={`${importPrefix}pdf/parceiros-oferta-conta-corrente.pdf`}
              target="_blank"
              id="pdf/parceiros-oferta-conta-corrente-footer-mobile"
              className="footer-itens"
            >
              <span>Parceiros oferta conta corrente</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );

  return (
    <>
      <footer>
        <ContainerHome24>
          <div className="categories">
            <div className="column">
              <span className="footer-topics">Meu financiamento</span>
              <a
                href={`${importPrefix}boleto.html`}
                id="segunda-via-de-boletos-footer-desktop"
                className="footer-itens"
              >
                <span>Meus boletos</span>
              </a>
              <a
                href={`${importPrefix}consultar-financiamento.html`}
                target="_blank"
                rel="noopener"
                id="consultar-financiamento-footer-desktop"
                className="footer-itens"
              >
                <span>Consultar Financiamento</span>
              </a>
              <a
                href={`${importPrefix}renegociacao-santander-financiamentos.html`}
                id="renegociacao-footer-desktop"
                className="footer-itens"
              >
                <span>Renegociação</span>
              </a>
              <a
                href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:footer&int_campaign=resumo-copia-de-contrato"
                target="_blank"
                rel="noopener"
                id="resumo-copia-contrato-footer-desktop"
                className="footer-itens"
              >
                <span>Resumo e/ou cópia do contrato</span>
              </a>
              <a
                href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:footer&int_campaign=transferencia-de-financiamento"
                target="_blank"
                rel="noopener"
                id="transferencia-do-financiamento-footer-desktop"
                className="footer-itens"
              >
                <span>Transferência do Financiamento</span>
              </a>
            </div>
            <div className="column">
              <span className="footer-topics">Produto</span>
              <a
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=footer&int_campaign=simular#/dados-pessoais"
                target="_blank"
                rel="noopener"
                id="simular-agora-footer-desktop"
                className="footer-itens"
              >
                <span>Simular agora</span>
              </a>
              <a
                href={`${importPrefix}banco-do-auto.html`}
                id="financiar-veiculos-footer-desktop"
                className="footer-itens"
              >
                <span>Financiar veículos</span>
              </a>
              <a
                href={`${importPrefix}financiamento-entre-particulares.html`}
                id="financiamento-entre-particulares-footer-desktop"
                className="footer-itens"
              >
                <span>Financiar veículo particular</span>
              </a>
              <a
                href={`${importPrefix}financiar-veiculos-eletricos.html`}
                id="financiar-veiculos-eletricos-footer-desktop"
                className="footer-itens"
              >
                <span>Veículos elétricos</span>
              </a>
              <a
                href={`${importPrefix}seguro-santander-auto.html`}
                id="seguro-santander-auto-footer-desktop"
                className="footer-itens"
              >
                <span>Seguro Auto</span>
              </a>
              <a
                href={`${importPrefix}leilao-de-veiculos.html`}
                id="leilao-de-veiculos-footer-desktop"
                className="footer-itens"
              >
                <span>Leilão de veículos</span>
              </a>
              <a
                href={`${importPrefix}open-finance.html`}
                id="open-finance-footer-desktop"
                className="footer-itens"
              >
                <span>Open Finance</span>
              </a>
              <a
                href={`${importPrefix}emprestimo-garantia-carro.html`}
                id="emprestimo-garantia-carro-footer-desktop"
                className="footer-itens"
              >
                <span>Empréstimo com Garantia de Veículo</span>
              </a>
            </div>
            <div className="column">
              <span className="footer-topics">Ajuda</span>
              <a
                href={`${importPrefix}canais-de-atendimento.html`}
                id="canais-de-atendimento-footer-desktop"
                className="footer-itens"
              >
                <span>Canais de atendimento</span>
              </a>
              <a
                href={`${importPrefix}duvidas-frequentes.html`}
                id="duvidas-frequentes-footer-desktop"
                className="footer-itens"
              >
                <span>Dúvidas frequentes</span>
              </a>
              <a
                href={`${importPrefix}denuncias-e-fraudes.html`}
                id="denuncias-e-fraudes-footer-desktop"
                className="footer-itens"
              >
                <span>Fraudes e segurança</span>
              </a>
            </div>
            <div className="column">
              <span className="footer-topics">Termos e condições</span>
              <a
                href={`${importPrefix}assets/seguro/pdf/14-11-25-em-diante.pdf`}
                target="_blank"
                id="condicoes-gerais-de-CDC-Auto-footer-desktop"
                className="footer-itens"
              >
                <span>Condições gerais de CDC Auto</span>
              </a>
              <a
                href={`${importPrefix}pdf/emprestimo-garantia-carro/condicoes-gerais-SIM-santander.pdf`}
                target="_blank"
                id="condicoes-gerais-de-emprestimo-com-garantia-de-veiculo-footer-desktop"
                className="footer-itens"
              >
                <span>Condições gerais de Empréstimo com garantia de veículo</span>
              </a>
              <a
                href={`${importPrefix}pdf/Tabela-de-Tarifas.pdf`}
                target="_blank"
                id="tabela-de-tarifas-footer-desktop"
                className="footer-itens"
              >
                <span>Tabela de tarifas</span>
              </a>
              <a
                href={`${importPrefix}politica-de-privacidade.html`}
                id="politica-de-privacidade-footer-desktop"
                className="footer-itens"
              >
                <span>Política de privacidade</span>
              </a>
              <a
                href={`${importPrefix}pdf/parceiros-oferta-conta-corrente.pdf`}
                target="_blank"
                id="pdf/parceiros-oferta-conta-corrente-footer-desktop"
                className="footer-itens"
              >
                <span>Parceiros oferta conta corrente</span>
              </a>
            </div>
          </div>

          <div id="categories-footer">
            {isAmp && (
              <amp-accordion disable-session-states="" animate="" expand-single-section="">
                {MobileContent}
              </amp-accordion>
            )}

            {!isAmp && <div>{MobileContent}</div>}
          </div>

          <div className="infobar">
            <div className="endereco">
              <span>
                ® SANTANDER SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A., CNPJ:
                07.707.650/0001-10
              </span>
              <span>
                Avenida Presidente Juscelino Kubitschek, nº 2041 - CJ 231 - Bloco A, Cond. WTORRE JK
                - Vila Nova Conceição - São Paulo-SP.
              </span>
            </div>
          </div>
        </ContainerHome24>
      </footer>
      <style jsx>{Style}</style>
    </>
  );
}

Footer24.defaultProps = {
  importPrefix: '',
};

export default Footer24;
